export const defaultProps = {
  dataRowHeight: 50,
  titleRowHeight: 35,
  headerRowHeight: 50,
  filterRowHeight: 30,
  rowGap: 15,
} as const;
